// extracted by mini-css-extract-plugin
var _1 = "EmailActionDeleteButton-moduledeleteButton__Zx9of";
export { _1 as "deleteButton" }
